<template>
    <AppSearchComponent
            :item-per-page="numOfTags"
            :list-items="sortedTags"
            :ready="ready"
            search-by="tag"
            v-bind="{notFoundSectionHeight}"
            searchable
    >
        <template v-slot:title>
            <h3 class="subheading font-weight-regular section-title--color">Tags</h3>
        </template>
        <template v-slot:no-items>No Tags Found</template>
        <template v-if="tags.length" v-slot:list-item="{listView}">
            <div class="px-3 py-3 chip-wrapper">
                <div style="display: flex;" class="align-center mb-2">
                    <span class="body-2 mr-2">Filter with:</span>
                    <v-radio-group
                            hide-details
                            v-model="filterByValue"
                            class="mt-0 mr-0 custom-radio-size"
                            row

                    >
                        <v-radio color="bindezcolor" :ripple="false" :key="item.value" v-for="item in filterBy" :value="item.value">
                            <template v-slot:label>
                                {{ item.name }}
                            </template>
                        </v-radio>
                    </v-radio-group>
                </div>
                <v-chip
                        class="chip--custom-margin"
                        :class="{'tags_highlight':selectedCustomTags.values.indexOf(tag.tag) > -1,'pointer-wait':!commentReady }"
                        :key="index"
                        @click="tagSelect(tag)"
                        color="#979797"
                        disabled
                        outline
                        v-for="(tag, index) in listView"
                >
                    <v-tooltip top>
                        <template slot="activator" slot-scope="{on}">
                            <v-icon
                                    :class="{'tags_highlight':selectedCustomTags.values.indexOf(tag.tag) > -1}"
                                    left
                                    small
                                    style="font-size: 15px; margin-right: 5px; padding-left: 5px;"
                                    v-on="on"
                            >
                                local_offer
                            </v-icon>
                        </template>
                        <span>{{ tag.tag }} {{ tag.count | formatNumber }}</span>
                    </v-tooltip>
                    <span class="add-cursor">{{tag.tag}}&nbsp;{{tag.count | abbrNumber}}</span>
                </v-chip>
            </div>
        </template>
    </AppSearchComponent>

</template>

<script>
	import {mapState, mapMutations} from 'vuex';
    import _cloneDeep from 'lodash/cloneDeep';
    import AppSearchComponent from "../AppSearchComponent";
	export default {
		name: "TagsFilter",
        components:{
			AppSearchComponent
        },
		model: {
			prop: "selectedCustomTags",
			event: "change",
		},
		props: {
            selectedCustomTags:{
				type:Object,
                required: true,
                default(){
					return {}
                }
            },
			tags: {
				type:Array,
				required: true,
				default() {
					return []
				}
			},

            numOfTags:{
				type:Number,
                required: true,
            },

			notFoundSectionHeight: {
				type: Number,
				default: 300,
			}
		},

		data() {
			return {
				filterByValue: "or",
				filterBy: [
					{name: "OR", value: "or"},
					{name: "AND", value: "and"},
				]
			}
		},
		computed: {

			...mapState('sentiment', [
				'sentimentPageReady',
				'commentReady',
			]),

			...mapState('mention', [
				'summaryReady'
			]),

			sortedTags() {
                let tags = _cloneDeep(this.tags);
				return tags.sort((a, b) => b.count - a.count);
			},

            ready(){
				return this.sentimentPageReady && this.summaryReady;
            },
		},

		watch: {
			filterByValue() {
				if (this.selectedCustomTags.values.length) this.tagSelect();
			}
		},

		methods: {
			...mapMutations('sentiment', [
				'setSelectedTags'
			]),

			tagSelect(tag) {
				if (!this.commentReady) return;
				this.$ua.trackEvent("Filter Comments", "check", "Filter Comments By Tags");
                let tags = this.selectedCustomTags.values;
				if (tag) {
					const index = this.selectedCustomTags.values.indexOf(tag.tag);
					tags = index > -1 ? this.selectedCustomTags.values.filter(t => t !== tag.tag) : [...this.selectedCustomTags.values, tag.tag];
				}
				let payload = {
					type:this.filterByValue,
					values: tags,
				};

				this.$emit("change", payload);
				this.$emit("filterByTags");
			}
		},
	}
</script>

<style scoped>
    .custom-radio-size >>> .v-input--selection-controls__input{
        margin-right: 0;
    }
</style>
